<script setup>

import {ref} from "vue";

const active = ref(false)
</script>

<template>
  <span class="info-popup" v-on:click="active = !active">
    <div v-if="active" class="ip__wrapper">
      <div class="ip__content">
        <slot></slot>
      </div>
    </div>
  </span>
</template>
